module.exports = __webpack_public_path__ + "img/service.2d9d6aaf.png";